import AppFormInput from '../../../../../../components/ui/AppFormInput';
import AppFormSelect from '../../../../../../components/ui/AppFormSelect';
import PhoneNumberInput from '../../../../../../components/common/PhoneNumberInput';
import React, { useState } from "react";
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { BlockUI } from 'primereact/blockui';
import { Avatar } from 'primereact/avatar';
import { Divider } from "primereact/divider";
import apiClient from "../../../../../../services/api-client";
import { Calendar } from "primereact/calendar";
import { SelectButton } from "primereact/selectbutton";
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useMountEffect } from 'primereact/hooks';
import BeneficiaryMembersJS from "./beneficiary-members-js";




const BeneficiaryMembersForm = ({ moveToNextView, moveToPreviousView, userPolicyInput, setuserPolicyInput, titles, toast }) => {
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [contextErrors, setContextErrors] = useState([]);
  const [loading, setloading] = useState(false);
  const [spouseSelected, setSpouseSelected] = useState(0);
  const [visible, setVisible] = useState(false);
  const [quoteParams, setQuoteParams] = useState([])
  const [allFormsInValid, setAllFormsInValid] = useState(true)
  const beneficiaryMembersJS = new BeneficiaryMembersJS();
  const [mainMemberProduct, setMainMemberProduct] = useState(0)
  const memberBeneficiary = [];
  const memberChild = [];
  const memberExtended = [];
  let memberSpouse = {};
  // const toast1 = useRef(null);

  const handleAddBeneficiary = () => { 
    let validator = true;
    beneficiaries.forEach((element, index) => {

      validator = validateAllFields(element, index)

    })

    if (userPolicyInput.selectedProduct && userPolicyInput.selectedProduct.includeParentProductInExtensions && (userPolicyInput.selectedProduct.includeParentProductInExtensions === true || userPolicyInput.selectedProduct.includeParentProductInExtensions + "" === "null")) {
      //console.log('Success | Include Parent is options  == ' + userPolicyInput.selectedProduct.includeParentProductInExtensions)
      userPolicyInput?.selectedProduct?.productExtensions?.push(userPolicyInput?.selectedProduct)
      setuserPolicyInput(userPolicyInput);
    } else {
      //console.log('Failure | Include Parent is options  == ' + userPolicyInput.selectedProduct.includeParentProductInExtensions)
    }

    if (!validator) return

    setBeneficiaries([...beneficiaries, { name: "", surname: "", relationship: "", dateOfBirth: "", idNumber: "", gender: '', firstName: "", lastName: "", phoneNumber: "", selectedProduct: userPolicyInput.selectedProduct, beneficiaryAge: 0, initials: "", isTertiary: '', active: false }]);
    setAllFormsInValid(false)
    setErrorMessage("");
  };

  function alterBeneficiaryArray(arr, index, newValue) {
    if (index >= 0 && index < arr.length) {
      arr[index] = newValue;
    } else {
      // console.error('Index out of range.');
    }
  }

  function clearContextErrors(index) {

    if (contextErrors.length > 0) {
      const newErrors = contextErrors.filter((element) => element.index !== index);

      setContextErrors(newErrors);
    }

  }

  function validateName(element, index) {
    try {
      clearContextErrors(index)
      if (element.name === '') {
        return { 'index': index, field: 'name', errorMessage: 'Please enter your name' }

      }
      if (element.name && element.name.split(" ").length < 2) {
        return { 'index': index, field: 'name', errorMessage: 'Please enter your full name' }
      } else {
        return true
      }
    } catch (error) {
      // //console.log(error)
    }
  }

  // function validateRelationship(element, index) {

  //   clearContextErrors(index)
  //   var numOfSpouse = 0;

  //   beneficiaries.forEach((element1) => {
  //     if (element1.relationship === "Spouse") {
  //       numOfSpouse = numOfSpouse + 1
  //     }
  //   });

  //   if(mainMemberProduct.CanHaveSpouse === 0 && element.relationship ==='Spouse'){
  //     return { 'index': index, field: 'relationship', errorMessage: 'The main member product does not allow spouse beneficiaries' }
  //   }

  //   if(mainMemberProduct.CanHaveChildren === 0 && element.relationship ==="Child"){
  //     return { 'index': index, field: 'relationship', errorMessage: 'The main member product does not allow children beneficiaries.' }
  //   }

  //   if (numOfSpouse > 1) {

  //     return { 'index': index, field: 'relationship', errorMessage: 'You can not have more than one spouse.' }
  //   }
  //   else if (element.relationship === '') {
  //     return { 'index': index, field: 'relationship', errorMessage: 'Please select your relationship with the beneficiary.' }
  //   }

  //   if (element.relationship === 'Child' && element.beneficiaryAge > 23) {
  //     changeRelationshipFromChild(index)
  //   }
  //   else {
  //     return true
  //   }

  // }
  function validateRelationship(element, index) {
    // //console.log("mainMemberProduct")
    // //console.log(userPolicyInput.selectedProduct.productExtensions)
    // //console.log("userPolicyInput.selectedProduct")
    clearContextErrors(index)
    var numOfSpouse = 0;

    beneficiaries.forEach((element1) => {
      if (element1.relationship === "Spouse") {

        if (mainMemberProduct.CanHaveChildren === 0) {
          return { 'index': index, field: 'relationship', errorMessage: 'Sorry, the product you selected can not have spouse as a beneficiary' }
        }
        numOfSpouse = numOfSpouse + 1
      }
    });

    if (Number(mainMemberProduct.CanHaveSpouse) === 0 && element.relationship === 'Spouse') {
      return { 'index': index, field: 'relationship', errorMessage: 'The main member product does not allow spouse beneficiaries' }
    }

    if (userPolicyInput.selectedProduct.productExtensions && userPolicyInput.selectedProduct.productExtensions.length === 0 && element.relationship === 'Relative') {
      return { 'index': index, field: 'relationship', errorMessage: 'This product does not allow relative beneficiaries' }
    }

    if (Number(mainMemberProduct.CanHaveChildren) === 0 && element.relationship === "Child") {
      return { 'index': index, field: 'relationship', errorMessage: 'The main member product does not allow children beneficiaries.' }
    }

    if (numOfSpouse > 1) {

      return { 'index': index, field: 'relationship', errorMessage: 'You can not have more than one spouse.' }
    }
    else if (element.relationship === '') {
      return { 'index': index, field: 'relationship', errorMessage: 'Please select your relationship with the beneficiary.' }
    }

    if (element.selectedProduct && (element.relationship === 'Child' && element.beneficiaryAge > Number(element.selectedProduct.ageTo))) {
      changeRelationshipFromChild(index)
    }

    return true

  }

  function changeRelationshipFromChild(index) {
    let arr = []
    beneficiaries.forEach((element, index1) => {
      if (index === index1) element.relationship = 'Relative'
      arr.push(element)
    })

    showToastMessage("Policy Guide", "You are not allowed to have a child beneficiary above 23, we have changed the relationship to relative. Please review", "info")

    setBeneficiaries(arr)
  }
  function validateDateOfBirth(element, index) {
    // //console.log("validate age element")
    // //console.log(element)
    // //console.log("validate age element")
    clearContextErrors(index)
    const benAge = beneficiaryMembersJS.validateAge(element.dateOfBirth);

    if (element.selectedProduct && (element.relationship === 'Child' && benAge > Number(element.selectedProduct.ageTo))) {
      // showToastMessage ("Relationship changed", 'Beneficiary not qualified to be a child beneficiary', 'info')
      // toast.current.show({ severity: 'info', summary: 'Sticky', detail: '', sticky: true });
      showToastMessage("Policy Guide", "You are not allowed to have a child beneficiary above " + Number(element.selectedProduct.ageTo) + ", we have changed the relationship to relative. Please review", "info")
      changeRelationshipFromChild(index)
    }

    if (element.dateOfBirth === '' || element.dateOfBirth === null) {
      return { 'index': index, errorMessage: 'Please select date of birth.' }
    }
    else if (element.selectedProduct && (benAge > Number(element.selectedProduct.ageTo) || benAge < Number(element.selectedProduct.ageFrom))) {
      return { 'index': index, errorMessage: 'Invalid beneficiary age, accepted age limit is between ' + Number(element.selectedProduct.ageFrom) + ' and ' + Number(element.selectedProduct.ageTo) + '.' }
    }
    else {
      return true
    }

  }

  function validateIdNumber(element, index) {
    clearContextErrors(index)

    if (element.idNumber === '') {
      return { 'index': index, errorMessage: 'Please enter the ID Number of the beneficiary.' }
    }

    return true

  }

  function validateGender(element, index) {
    clearContextErrors(index)

    if (element.gender === '') {
      return { 'index': index, errorMessage: 'Please select gender of the beneficiary.' }
    }

    return true

  }

  function validateTertiary(element, index) {
    clearContextErrors(index)
    // //console.log("Log")
    // //console.log(element)

    if (element.dateOfBirth != null) {

      const age = beneficiaryMembersJS.validateAge(element.dateOfBirth);

      if (element.isTertiary === '' && age > 18 && element.relationship === 'Child') {
        return { 'index': index, errorMessage: 'Please tell us whether  the beneficiary is still in tertiary.' }
      }
    }


    return true

  }

  function validateProduct(element, index) {
    clearContextErrors(index)

    // //console.log(element)

    if (element.relationship === "Relative") {

      // //console.log("START")
      // //console.log(element.selectedProduct)
      // //console.log(userPolicyInput.selectedProduct.productExtensions)
      // //console.log("END")

      if (!element.selectedProduct || !element.selectedProduct.ProductID) {
        // If selectedProduct is not defined or ProductID is missing, exit early.
        return { 'index': index, errorMessage: 'Please select a product for the member added.' };
      }

      const doesExist = userPolicyInput.selectedProduct.productExtensions.some(extension =>
        extension.ProductID === element.selectedProduct.ProductID
      );

      if (!doesExist) {
        return { 'index': index, errorMessage: 'Please select a product for the member added.' };
      }




    }


    return true
  }

  function validateAllFields(element, index) {
    const validationFunctions = [
      validateName,
      validateRelationship,
      validateDateOfBirth,
      validateIdNumber,
      validateGender,
      validateTertiary,
      validateProduct
    ];

    const concatenatedObj = [];
    let isValid = true;

    for (const validateFn of validationFunctions) {
      const result = validateFn(element, index);

      if (typeof result === 'object') {
        concatenatedObj.push(result);
      }

      isValid = isValid && result === true;
    }

    if (isValid) setAllFormsInValid(false)

    setContextErrors(concatenatedObj);
    return isValid;
  }

  function getMainMemberPolicy() {
    userPolicyInput.selectedSubGroupPlan.planProducts.forEach((element) => {

      if (Number(element.ProductID) === Number(userPolicyInput.selectedProduct.ProductID)) {
        setMainMemberProduct(element)
      }


    })

  }


  function populateForExisting() {

    let existingBeneficiaries = []
    if (userPolicyInput.memberSpouse) {
      existingBeneficiaries.push({ name: userPolicyInput.memberSpouse.Name, surname: userPolicyInput.memberSpouse.Surname, relationship: "Spouse", dateOfBirth: userPolicyInput.memberSpouse.Date_of_Birth, idNumber: userPolicyInput.memberSpouse.ID_Num, gender: userPolicyInput.memberSpouse.Gender, firstName: "", lastName: "", phoneNumber: userPolicyInput.memberSpouse.Telephone, selectedProduct: userPolicyInput.selectedProduct, beneficiaryAge: userPolicyInput.memberSpouse.Age, initials: userPolicyInput.memberSpouse.Initials, isTertiary: '', active: false });
    }

    if (userPolicyInput.memberChild && userPolicyInput.memberChild.length > 0) {
      userPolicyInput.memberChild.forEach(element => {

        // //console.log(element)
        existingBeneficiaries.push({ name: element.Name, surname: element.Surname, relationship: "Child", dateOfBirth: element.Date_of_birth, idNumber: element.ID_num, gender: element.Gender, firstName: "", lastName: "", phoneNumber: element.Telephone, selectedProduct: userPolicyInput.selectedProduct, beneficiaryAge: element.Age, initials: element.Initials, isTertiary: element.AtVarsity ? 'YES' : 'NO', active: false });
      });
    }

    setBeneficiaries(existingBeneficiaries)
  }

  useMountEffect(() => {
    getMainMemberPolicy()
    populateForExisting()

  });



  const moveToNext = (e) => {

    // let validator = true;
    // beneficiaries.forEach((element, index) => {
    //   validator = validateAllFields(element, index)
    //   if (!validator) return
    // })

    let validator = true;
    beneficiaries.forEach((element, index) => {

      validator = validateAllFields(element, index)

    })

    if (!validator) return


    var errorsExist = false

    const errors = [];

    for (const [index, beneficiary] of beneficiaries.entries()) {

      if (!beneficiaryMembersJS.validateFields(beneficiary)) {

        errors.push({ index: index, field: 'allerrors', errorMessage: `Please fill in all fields for beneficiary ${index + 1}` });
      }
    }

    if (errors.length > 0) {
      setContextErrors(errors);
      return;
    }

    const calculateAge = (dateOfBirth) => {
      const birthDate = new Date(dateOfBirth);
      const currentDate = new Date();

      const yearsDiff = currentDate.getFullYear() - birthDate.getFullYear();
      const monthsDiff = currentDate.getMonth() - birthDate.getMonth();

      if (monthsDiff < 0 || (monthsDiff === 0 && currentDate.getDate() < birthDate.getDate())) {
        return yearsDiff - 1;
      } else {
        return yearsDiff;
      }
    };

    beneficiaries.forEach((beneficiary) => {

      const beneficiaryDateOfBirth = beneficiary.dateOfBirth
      const beneficiaryAge = calculateAge(beneficiaryDateOfBirth);
      if (beneficiary.selectedProduct && (beneficiaryAge < Number(beneficiary.selectedProduct.ageFrom) && beneficiaryAge > Number(beneficiary.selectedProduct.ageTo))) {

      }

      if (beneficiary.relationship === "Spouse") {

        memberSpouse = ({
          Name: beneficiary.name,
          Initials: beneficiary.initials,
          Surname: beneficiary.lastName,
          ID_Num: beneficiary.idNumber,
          DateOfBirth: beneficiaryMembersJS.formatDateToDDMMYYYY(beneficiaryDateOfBirth),
          Gender: beneficiary.gender,
          Incep_Date: beneficiaryMembersJS.formatDateToDDMMYYYY("2023-08-03"),
          Telephone: beneficiary.phoneNumber,
          Cover: 0,
        });
      } else if (beneficiary.relationship === "Child") {
        memberChild.push({
          FirstName: beneficiary.firstName,
          LastName: beneficiary.lastName,
          IdNumber: beneficiary.idNumber,
          DateOfBirth: beneficiaryMembersJS.formatDateToDDMMYYYY(beneficiaryDateOfBirth),
          Gender: beneficiary.gender,
          InceptionDate: beneficiaryMembersJS.formatDateToDDMMYYYY("2023-08-03"),
          AtVarsity: false,
          Cover: 0,
          Telephone: beneficiary.phoneNumber,
          waitingPeriod: 0,
        });
      } else if (beneficiary.relationship === "Grandfather" || beneficiary.relationship === "Grandmother") {
        memberExtended.push({
          ProductId: beneficiary.selectedProduct,
          FirstName: beneficiary.firstName,
          LastName: beneficiary.lastName,
          IdNumber: beneficiary.idNumber,
          DateOfBirth: beneficiaryMembersJS.formatDateToDDMMYYYY(beneficiaryDateOfBirth),
          Gender: beneficiary.gender,
          InceptionDate: beneficiaryMembersJS.formatDateToDDMMYYYY("2023-08-03"),
          Relationship: beneficiary.relationship.toUpperCase(),
          Telephone: beneficiary.phoneNumber,
          Cover: 0,
        });
      } else {
        memberBeneficiary.push({
          ProductId: beneficiary.selectedProduct.ProductID,
          FirstName: beneficiary.firstName,
          LastName: beneficiary.lastName,
          IdNumber: beneficiary.idNumber,
          DateOfBirth: beneficiaryMembersJS.formatDateToDDMMYYYY(beneficiaryDateOfBirth),
          Gender: beneficiary.gender,
          InceptionDate: beneficiaryMembersJS.formatDateToDDMMYYYY("2023-08-03"),
          Relationship: beneficiary.relationship.toUpperCase(),
          Telephone: beneficiary.phoneNumber,
          Cover: 0,
        });
      }
    });
    const payload = {
      "operation": "createPolicyApplicationStage2",
      "requestBody": {
        "planId": userPolicyInput.selectedPlanName,
        "planName": userPolicyInput.selectedPlanID,
        "productId": userPolicyInput.selectedProductId,
        "productName": userPolicyInput.selectedProductName,
        "applicationTotalStages": 5,
        "currentStages": 3,
        "applicationType": userPolicyInput.selectedPlanType,
        "mainMember": userPolicyInput.mainMember,
        "memberSpouse": memberSpouse,
        "memberChild": memberChild,
        "memberExtended": memberExtended,
        "memberBeneficiary": memberBeneficiary

      }
    }
    setuserPolicyInput({ ...userPolicyInput, memberSpouse: memberSpouse, memberChild: memberChild, memberExtended: memberExtended, memberBeneficiary: memberBeneficiary });
    submitStage2toServer(payload);

  }


  const confirm1 = (event, index) => {
    confirmPopup({
      target: event.originalEvent.target,
      message: event.value === "YES" ? 'Are you sure this beneficiary is a tertiary student?' : 'Kindly confirm this beneficiary is not a tertiary student?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => acceptTertiary(event, index),
      reject: () => rejectTertiary(event, index)
    });
  };


  const acceptTertiary = (e, index) => {

    const updatedBeneficiaries = [...beneficiaries];
    if (e.value === 'YES') {
      updatedBeneficiaries[index].isTertiary = e.value;
      setBeneficiaries(updatedBeneficiaries);
    }
    else {
      updatedBeneficiaries[index].relationship = "Relative";
      setBeneficiaries(updatedBeneficiaries);
      showToastMessage("Policy Guide", "Your child beneficiary is above 18 and not in tertiary education, we have changed the relationship to relative. Please review", "info")
    }

  };

  const rejectTertiary = (e, index) => {

  };

  function ProductDropdown({ index, selectedProduct, handleProductChange, planProducts }) {
    // //console.log("/n/n/n/n/n/n/n -------")
    // //console.log(userPolicyInput)
    // //console.log(mainMemberProduct)

    // const arr = planProducts.filter((product, index) => {
    //   const a = product.CanHaveChildren === "0" && product.Total <= mainMemberProduct.Total
    //   // //console.log(index + "First Part requests "+(product.CanHaveChildren === "0"))
    //   // //console.log(index + "Second part "+(product.Total <= mainMemberProduct.Total)+ "=== values ===product = "+product.Total +" main member ="+mainMemberProduct.Total)
    //   // //console.log(index + "All requests "+a)
    //   return a
    // });

    //  if (selectedProduct && selectedProduct.includeParentProductInExtensions  && selectedProduct.includeParentProductInExtensions=== true){
    //   //console.log('SOLVING ISSUES')
    //   //console.log(selectedProduct)
    //   //console.log(selectedProduct.includeParentProductInExtensions)
    //   //console.log(planProducts.productExtensions)
    //  }else{
    //   //console.log('SOLVING ISSUES')
    //   //console.log(selectedProduct)
    //   //console.log(selectedProduct.includeParentProductInExtensions)
    //  }
    return (
      <Dropdown
        id={`product${index}`}
        name="selectedProduct"
        value={selectedProduct}
        onChange={(e) => handleProductChange(e, index)}
        options={planProducts.productExtensions}
        required
        optionLabel="ProductName1"
        placeholder={planProducts.productExtensions.length === 0 ? "No products for additional beneficiaries in this package" : "Select a product"}
        className="w-full md:w-6rem"
      />
    );
  }

  const handleRemoveBeneficiary = (index) => {
    const updatedBeneficiaries = [...beneficiaries];
    updatedBeneficiaries.splice(index, 1);
    setBeneficiaries(updatedBeneficiaries);
  };

  const handleBeneficiaryChange = (e, index) => {

    const { name, value } = e.target;

    const updatedBeneficiaries = [...beneficiaries];
    if (name === "dateOfBirth") {
      const benAge = beneficiaryMembersJS.validateAge(value);
      updatedBeneficiaries[index]["beneficiaryAge"] = benAge;
    }

    if (name === "name") {
      const nameDetails = beneficiaryMembersJS.generateNameDetails(value);
      updatedBeneficiaries[index].firstName = nameDetails.firstName;
      updatedBeneficiaries[index].lastName = nameDetails.lastName;
      updatedBeneficiaries[index].initials = nameDetails.initials;
    }

    updatedBeneficiaries[index][name] = value;
    setBeneficiaries(updatedBeneficiaries);
  };


  const handleGenderChange = (e, index) => {
    const { name, value } = e.target;
    const updatedGender = [...beneficiaries];
    updatedGender[index][name] = value;
    setBeneficiaries(updatedGender);
  }

  const handleProductChange = (e, index) => {


    const { name, value } = e.target;
    const updatedProduct = [...beneficiaries];
    updatedProduct[index][name] = value;
    setBeneficiaries(updatedProduct);
  }

  const showToastMessage = (title, message, messageType) => {
    toast.current.show({ severity: messageType, summary: title, detail: message, life: 15000 });
  }

  const relationshipOptions = [
    "Spouse",
    "Child",
    "Relative",
  ];

  const submitStage2toServer = async (payload) => {
    showToastMessage("Progress Saved", userPolicyInput.mainMemberName + " your progress will be updated after confirmation", "success");
    moveToNextView();
  }

  return (
    <div className="w-full max-w-7xl mx-auto mb-12 px-4">
      <ConfirmPopup />
      <BlockUI blocked={loading}>
        
        <div className="card bg-base-100 shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-base-200/60 overflow-hidden rounded-2xl">
            <div className="bg-base-200/50 px-8 py-6 border-b border-base-200">
                <h3 className="text-2xl font-bold text-base-content mb-1">Add Beneficiaries</h3>
                <p className="text-base-content/70 text-sm">Add the dependents and relatives you wish to cover on this policy.</p>
            </div>
            
            <div className="p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                
                {beneficiaries.map((beneficiary, index) => (
                  <div key={index} className="card bg-white shadow-sm border border-base-200 hover:shadow-md transition-all duration-200 flex flex-col relative overflow-hidden">
                    
                    <div className="bg-primary/5 px-4 py-3 border-b border-base-200 flex justify-between items-center">
                      <h4 className="font-bold text-primary flex items-center gap-2">
                        <i className="pi pi-user text-lg"></i> Beneficiary {index + 1}
                      </h4>
                      <button 
                        type="button" 
                        onClick={() => handleRemoveBeneficiary(index)}
                        className="btn btn-ghost btn-xs text-error hover:bg-error/10 rounded-full w-8 h-8 p-0 flex items-center justify-center"
                        title="Remove Beneficiary"
                      >
                        <i className="pi pi-times"></i>
                      </button>
                    </div>

                    <div className="card-body p-5 flex flex-col gap-4">
                      
                      <AppFormInput
                        label="First Name"
                        id={`firstName${index}`}
                        name="name"
                        placeholder="First Name"
                        value={beneficiary.firstName}
                        onChange={(e) => {
                          validateAllFields(beneficiary, index);
                          handleBeneficiaryChange(e, index);
                        }}
                        required
                        containerClassName="w-full"
                      />
                      
                      <AppFormInput
                        label="Surname"
                        id={`surname${index}`}
                        name="surname"
                        placeholder="Surname"
                        value={beneficiary.surname}
                        onChange={(e) => {
                          validateAllFields(beneficiary, index);
                          handleBeneficiaryChange(e, index);
                        }}
                        required
                        containerClassName="w-full"
                      />

                      <AppFormSelect
                        label="Relationship"
                        id={`relationship${index}`}
                        name="relationship"
                        placeholder="Select Relationship"
                        value={beneficiary.relationship}
                        onChange={(e) => {
                          validateAllFields(beneficiary, index);
                          handleBeneficiaryChange(e, index);
                        }}
                        options={relationshipOptions.filter(opt => opt !== 'Extended Family')}
                        required
                        containerClassName="w-full"
                      />

                      <AppFormSelect
                        label="Gender"
                        id={`gender${index}`}
                        name="gender"
                        placeholder="Select Gender"
                        value={beneficiary.gender}
                        onChange={(e) => {
                          validateAllFields(beneficiary, index);
                          handleGenderChange(e, index);
                        }}
                        options={[ {name: 'MALE', value: 'MALE'}, {name: 'FEMALE', value: 'FEMALE'} ]}
                        optionLabel="name"
                        required
                        containerClassName="w-full"
                      />

                      <AppFormInput
                        label="Date of Birth"
                        type="date"
                        id={`dateOfBirth${index}`}
                        name="dateOfBirth"
                        placeholder="Date of Birth"
                        value={beneficiary.dateOfBirth}
                        onChange={(e) => {
                          validateAllFields(beneficiary, index);
                          handleBeneficiaryChange(e, index);
                        }}
                        required
                        containerClassName="w-full"
                      />

                      <AppFormInput
                        label="ID Number"
                        id={`idNumber${index}`}
                        name="idNumber"
                        placeholder="ID Number"
                        value={beneficiary.idNumber}
                        onChange={(e) => {
                          validateAllFields(beneficiary, index);
                          handleBeneficiaryChange(e, index);
                        }}
                        required
                        containerClassName="w-full"
                      />

                      <PhoneNumberInput
                        label="Phone Number"
                        id={`phoneNumber${index}`}
                        name="phoneNumber"
                        placeholder="Phone Number"
                        value={beneficiary.phoneNumber}
                        onChange={(val) => {
                          validateAllFields(beneficiary, index);
                          handleBeneficiaryChange({ target: { name: 'phoneNumber', value: val } }, index);
                        }}
                        containerClassName="w-full"
                      />

                      {beneficiary.relationship === "Relative" && userPolicyInput.selectedSubGroupPlan && (
                        <div className="w-full border-t border-base-200 pt-4 mt-2">
                          <ProductDropdown
                            index={index}
                            selectedProduct={beneficiary.selectedProduct}
                            handleProductChange={handleProductChange}
                            planProducts={userPolicyInput.selectedProduct}
                          />
                        </div>
                      )}

                      {beneficiary.relationship === "Child" && beneficiary.beneficiaryAge > 18 && (
                        <div className="w-full bg-base-200/50 p-4 rounded-xl border border-base-200 mt-2">
                          <label className="font-bold text-sm text-base-content mb-3 block">Is beneficiary a tertiary student?</label>
                          <div className="flex justify-center">
                            <SelectButton 
                              disabled={beneficiary.active} 
                              name="selectButton" 
                              id="selectButton" 
                              value={beneficiary.isTertiary} 
                              onChange={(e) => {
                                if (e.value === null && beneficiary.isTertiary === "YES") e.value = "YES";
                                else if (e.value === null && beneficiary.isTertiary === "NO") e.value = "NO";
                                if (e.value === beneficiary.isTertiary) return true;
                                confirm1(e, index);
                              }}
                              options={['YES', 'NO']} 
                            />
                          </div>
                        </div>
                      )}

                      {contextErrors.filter(err => err.index === index).map((element, index1) => (
                        <div key={index1} className="alert alert-error text-sm py-2 px-3 mt-2 rounded-lg">
                          <i className="pi pi-exclamation-triangle"></i>
                          <span>{element.errorMessage}</span>
                        </div>
                      ))}

                    </div>
                  </div>
                ))}
                
                <div 
                  className="card border-2 border-dashed border-base-300 hover:border-primary/50 bg-base-50/50 hover:bg-base-100 transition-all duration-300 flex flex-col items-center justify-center p-8 min-h-[30rem] cursor-pointer group rounded-2xl"
                  onClick={handleAddBeneficiary}
                >
                  <div className="w-20 h-20 rounded-full bg-primary/10 text-primary flex items-center justify-center mb-4 group-hover:scale-110 group-hover:bg-primary/20 transition-all duration-300">
                    <i className="pi pi-user-plus text-3xl"></i>
                  </div>
                  <h4 className="text-lg font-bold text-base-content mb-2 group-hover:text-primary transition-colors">Add Beneficiary</h4>
                  <p className="text-center text-sm text-base-content/60 px-4">Click here to add another dependent or relative to your policy cover.</p>
                </div>
                
              </div>
              
              <div className="card-actions flex flex-col items-end mt-10 pt-6 border-t border-base-200/50">
                
                {beneficiaries.length > 0 && (
                  <button 
                    type="button"
                    onClick={() => {
                      setQuoteParams(beneficiaryMembersJS.generateQuote(userPolicyInput.mainMember, mainMemberProduct, beneficiaries))
                      setVisible(true)
                    }}
                    className="btn btn-outline btn-info rounded-full px-8 mb-4 shadow-sm"
                  >
                    <i className="pi pi-info-circle mr-2"></i> View Quotation Info
                  </button>
                )}

                <button 
                  onClick={moveToNext} 
                  className="btn btn-primary rounded-full px-12 shadow-md hover:shadow-lg transition-all font-bold tracking-wide text-white"
                >
                  Continue <i className="pi pi-arrow-right ml-2 text-sm"></i>
                </button>
              </div>

            </div>

            <Dialog header="Quotation" visible={visible} style={{ width: '60vw' }} onHide={() => setVisible(false)}>
              <DataTable value={quoteParams} tableStyle={{ minWidth: '50rem' }}>
                <Column field="name" header="Name"></Column>
                <Column field="relationship" header="Relationship"></Column>
                <Column field="totalContribution" header="Premium Contribution"></Column>
              </DataTable>
            </Dialog>

        </div>
      </BlockUI>
    </div>
  );
};

export default BeneficiaryMembersForm;